import { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import SessionClientOnboard from 'dashboard/lib/clients/SessionClientOnboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { PasswordReset } from 'dashboard/models/password-reset';
import { clearMessages, showMessage } from 'dashboard/redux/actions/messages';
import { savePasswordReset } from 'dashboard/redux/actions/password-reset';
import { RootState } from 'dashboard/redux/store';
import DashboardPasswordResetView from 'dashboard/views/DashboardPasswordResetView';
import { ApiModel } from 'lib/interfaces/api';

const DashboardPasswordResetRoute = (props: PropsFromRedux) => {
  const [resetSent, setResetSent] = useState(false);
  const [submittingResend, setSubmittingResend] = useState(false);
  const [passwordResetEmailAddress, setPasswordResetEmailAddress] = useState('');

  const resendReset = async () => {
    props.clearMessages();
    setSubmittingResend(true);

    try {
      await SessionClientOnboard.postResourceAction<PasswordReset>(
        {
          type: ApiModel.PasswordResetEmail,
          id: props.passwordReset.id,
        },
        'resend-instructions',
      );

      props.showMessage('Reset email resent', MessageType.Success);
    } catch {
      createReset({ emailAddress: passwordResetEmailAddress });
    } finally {
      setSubmittingResend(false);
    }
  };

  const createReset = async ({ emailAddress }: { emailAddress: string }) => {
    props.clearMessages();

    setPasswordResetEmailAddress(emailAddress);

    try {
      const passwordResetResponse = await SessionClientOnboard.postResourceCreate<PasswordReset>(
        {
          type: ApiModel.PasswordResetEmail,
        },
        {
          meta: {
            'email-address': emailAddress,
          },
        },
      );

      props.savePasswordReset(passwordResetResponse.data);
      setResetSent(true);
    } catch (err) {
      props.showMessage('Please enter a valid email address', MessageType.Failure);
    }
  };

  return (
    <DashboardPasswordResetView
      createReset={createReset}
      resetSent={resetSent}
      submittingResend={submittingResend}
      resendReset={resendReset}
    />
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    passwordReset: state.passwordReset.passwordReset,
  };
};

const mapDispatchToProps = {
  savePasswordReset,
  clearMessages,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardPasswordResetRoute);
